module.exports = __webpack_public_path__ + "img/icon_develop_01.26797e78.png";